import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faBriefcase, faMugHot } from "@awesome.me/kit-70c1f0055f/icons/classic/light";
import type { AniPersonalityMode } from "@/context/AniContext";
import {faPartyHorn as faPartyHornSolid} from "@awesome.me/kit-70c1f0055f/icons/duotone/solid";



/**
 * Font Awesome icons for each Ani personality mode (tone / style).
 */
export const ANI_PERSONALITY_MODE_ICONS: Record<AniPersonalityMode, IconDefinition> = {
  professional: faBriefcase,
  casual: faMugHot,
  fun: faPartyHornSolid,
};
